<template>
  <section>
    <gs-header title="Cấu hình cài đặt">
    </gs-header>
    <div class="padding-all">
      <el-form :model="localSetting" :rules="rules" ref="updateSettingForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitRegion('updateSettingForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localSetting.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Địa chỉ" prop="address">
              <el-input v-model="localSetting.address" placeholder="Địa chỉ"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Tiêu đề seo" prop="meta_title">
              <el-input v-model="localSetting.meta_title" placeholder="Tiêu đề seo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Từ khóa seo" prop="meta_keyword">
              <el-input type="textarea" v-model="localSetting.meta_keyword" placeholder="Từ khóa seo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Mô tả seo" prop="meta_description">
              <el-input type="textarea" v-model="localSetting.meta_description" placeholder="Mô tả seo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Mô tả" prop="description">
              <el-input type="textarea" v-model="localSetting.description" placeholder="Mô tả"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Mô tả ngắn" prop="short_description">
              <el-input v-model="localSetting.short_description" placeholder="Mô tả ngắn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Facebook">
              <el-input v-model="localSetting.facebook" placeholder="Facebook"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Googleplus">
              <el-input v-model="localSetting.googleplus" placeholder="Googleplus"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Twitter">
              <el-input v-model="localSetting.twitter" placeholder="Twitter"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Linkin">
              <el-input v-model="localSetting.linkin" placeholder="Linkin"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Youtube">
              <el-input v-model="localSetting.youtube" placeholder="Youtube"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Js_codes">
              <el-input v-model="localSetting.js_codes" placeholder="Js_codes"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Email_1" prop="email_1">
              <el-input v-model="localSetting.email_1" placeholder="Email_1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Email_2" prop="email_2">
              <el-input v-model="localSetting.email_2" placeholder="Email_2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Email_3" prop="email_3">
              <el-input v-model="localSetting.email_3" placeholder="Email_3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Phone_1" prop="Phone_1">
              <el-input v-model="localSetting.phone_1" placeholder="Phone_1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Phone_2" prop="Phone_2">
              <el-input v-model="localSetting.phone_2" placeholder="Phone_2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Phone_3" prop="Phone_3">
              <el-input v-model="localSetting.phone_3" placeholder="Phone_3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Skype_1">
              <el-input v-model="localSetting.skype_1" placeholder="Skype_1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Skype_2">
              <el-input v-model="localSetting.skype_2" placeholder="Skype_2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Skype_3">
              <el-input v-model="localSetting.skype_3" placeholder="Skype_3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Yahoo_1">
              <el-input v-model="localSetting.yahoo_1" placeholder="Yahoo_1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Yahoo_2">
              <el-input v-model="localSetting.yahoo_2" placeholder="Yahoo_2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Yahoo_3">
              <el-input v-model="localSetting.yahoo_3" placeholder="Yahoo_3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>

<script>
import { getSetting, updateSetting } from 'src/api/settings'
import { head } from 'lodash'
export default {

  name: 'Setting',

  data () {
    return {
      localSetting: {
        name: '',
        address: '',
        email_1: '',
        email_2: '',
        email_3: '',
        phone_1: '',
        phone_2: '',
        phone_3: '',
        skype_1: '',
        skype_2: '',
        skype_3: '',
        yahoo_1: '',
        yahoo_2: '',
        yahoo_3: '',
        short_description: '',
        description: '',
        meta_title: '',
        meta_keyword: '',
        meta_description: '',
        facebook: '',
        googleplus: '',
        twitter: '',
        linkin: '',
        youtube: '',
        js_codes: ''
      },
      rules: {
        name: [
          {required: true, message: 'Bạn chưa nhập tên', trigger: 'change'},
          {max: 255, message: 'Tên phải nhỏ hơn  255 ký tự', trigger: 'change'}
        ],
        address: [
          {required: true, message: 'Bạn chưa nhập địa chỉ', trigger: 'change'},
          {max: 255, message: 'Địa chỉ phải nhỏ hơn  255 ký tự', trigger: 'change'}
        ],
        meta_title: [
          {required: true, message: 'Bạn chưa nhập tiêu đề seo', trigger: 'change'},
          {max: 255, message: 'Tiêu đề seo phải nhỏ hơn  255 ký tự', trigger: 'change'}
        ],
        meta_keyword: [
          {required: true, message: 'Bạn chưa nhập từ khóa seo', trigger: 'change'}
        ],
        meta_description: [
          {required: true, message: 'Bạn chưa nhập mô tả seo', trigger: 'change'}
        ],
        short_description: [
          {max: 255, message: 'Mô tả ngắn phải nhỏ hơn  255 ký tự', trigger: 'change'}
        ],
        email_1: [
          {required: true, message: 'Bạn chưa nhập email_1', trigger: 'change'},
          {type: 'email', message: 'Email_1 không đúng định dạng', trigger: 'change'}
        ],
        email_2: [
          {type: 'email', message: 'Email_2 không đúng định dạng', trigger: 'change'}
        ],
        email_3: [
          {type: 'email', message: 'Email_3 không đúng định dạng', trigger: 'change'}
        ],
        phone_1: [
          {required: true, message: 'Bạn chưa nhập phone_1', trigger: 'change'},
          {min: 8, max: 12, message: 'Phone_1 phải lớn hơn 8 và nhỏ hơn  12 ký tự', trigger: 'change'}
        ],
        phone_2: [
          {min: 8, max: 12, message: 'Phone_2 phải lớn hơn 8 và nhỏ hơn  12 ký tự', trigger: 'change'}
        ],
        phone_3: [
          {min: 8, max: 12, message: 'Phone_3 phải lớn hơn 8 và nhỏ hơn  12 ký tự', trigger: 'change'}
        ]
      },
      submitting: false
    }
  },
  methods: {
    validateBeforeSubmitRegion () {
      this.submitting = true
      this.toggleLoadding()
      this.$refs.updateSettingForm.validate(valid => {
        if (valid) {
          this.changedData = false
          updateSetting(this.localSetting.id, this.localSetting).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Cấu hình thành công',
                  body: 'Cấu hình thông tin cài đặt thành công'
                })
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    }
  },
  mounted () {
    getSetting(1, {}).then(response => {
      switch (response.code) {
        case 200:
          this.localSetting = response.data
          setTimeout(() => {
            this.watching = true
          }, 100)
          break
        case 404:
          this.$store.dispatch('showNotify', {
            title: 'Không tìm thấy tài nguyên',
            body: 'Thông tin cài đặt không tồn tại trên hệ thống',
            type: 'warning'
          }, {root: true})
          this.$route.push({name: 'home'})
          break
        default:
      }
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Setting.vue?f3c5be64